/**
 * Holidays for Phone in different countries
 */
export const HELP_CENTER_PHONE_HOLIDAYS = 'HELP_CENTER_PHONE_HOLIDAYS';
